var App = App || {};

App.InfoBlock = (function ($) {
    "use strict";

    function init() {
        var $carousel = $('.info-block__carousel');

        $carousel.slick({
            arrows: true,
            autoplay: false,
            dots: false,
            draggable: false,
            adaptiveHeight: true
        });


        $(".block-video-modal").on("shown.bs.modal", function (event) {
            var trigger = event.relatedTarget;

            if (trigger) {
                var $this = $(this),
                    src = $(trigger).data("src"),
                    title = $(trigger).data("title"),
                    $placeholder = $this.find(".placeholder"); 

                if ($placeholder) {
                    $placeholder.html(generateIframe(src, title));

                    $this.one("hidden.bs.modal", function () {
                        $placeholder.html("");
                    });
                }
            }
        });

        function generateIframe(src, title) {
            if (src && src.toLowerCase().indexOf("vimeo") >= 0) {
                return $("<iframe>", {
                    src: src,
                    title: title,
                    frameborder: 0,
                    allow: "autoplay; fullscreen; picture-in-picture",
                    allowfullscreen: true
                });
            }

            return $("<iframe>", {
                src: src,
                title: title,
                frameborder: 0,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: true
            });
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.InfoBlock.init();
});